export default __webpack_public_path__ + "static/media/GHSI Related Party Transaction Charter.12181e6c.pdf";